import React, { useEffect, useState } from 'react'
import image from '../flag.png'
import {db} from '../firebase'
import {useNavigate} from 'react-router-dom'
function Todo({user}) {
    const history = useNavigate()
    const[text,setText] = useState('');
    const[date,setDate] = useState('');
    const[mytodos,setTodos] = useState([])  
    useEffect(()=>{
        if(user){
            const ref = db.collection('todos').doc(user.uid)
            ref.onSnapshot(docSnap =>{
                if(docSnap.exists){
                    setTodos(docSnap.data().todos)
                }
                else{
                    console.log('no todo')
                }
            })
        }else{
            history('/')
        }
    },[]) 
    const todoDoc={
        text,
        date
    }
    const addTodo =() =>{
      if(text === "" || date ==="")
      alert("All fields are mandatory")
      else{
        db.collection('todos').doc(user.uid).set({
            todos:[...mytodos,todoDoc]
        })
      }
        setText('')
        setDate('')
    }
    const deleteTodo = (deleteTodo) =>{
        const ref = db.collection('todos').doc(user.uid)
        ref.get().then(snap=>{
            const result =  snap.data().todos.filter(todo => todo.text !==  deleteTodo.text)
            ref.update({
                todos:result
            })
        })
    }
    const updateTodo = (todo) =>{
        setText(todo.text)
        setDate(todo.date)
        deleteTodo(todo)    
    }
    const a =[] 
  var i=0;
  mytodos.map((user)=>{
      let d1 = new Date(user.date).getTime();
      let d2 = new Date().getTime();
      let diff = d1-d2;
      let days = Math.ceil(diff/(1000*3600*24));
      a[i++]=days;
  })
  return (
    <div className='container'>
        <h1>Add Todos</h1>
        <div className="input-field">
                <input type="text" name="todo" value={text} required onChange={e=>setText(e.target.value)} placeholder='Enter todo' />
                <input type="date" name="date" value={date} required onChange={e=>setDate(e.target.value)} />
            </div>
            <button className='btn blue' onClick={addTodo}>Add</button>
            <h3>Your Todos</h3>
     <table className="table border shadow">
  <thead>
    <tr >
      <th scope="col" >#</th>
      <th scope="col">Todo</th>
      <th scope="col">Due Date</th>
      <th>Action</th>
      <th>Days Left</th>
    </tr>
  </thead>
  <tbody>
    {
      mytodos.map((user,index)=>(
        <tr key={index+1}>
      <th scope="row">{index+1}</th>
      <td>{user.text}</td>
      <td>{a[index] >= 0 ? user.date :  <img src={image} alt="red flag" style={{width:'20px'}}/> }</td>
      <td style={{float:'left'}}>
      <i className="material-icons right" onClick={()=>updateTodo(user)} style={{cursor:'pointer'}}>edit</i>
      <i className="material-icons right" onClick={()=>deleteTodo(user)} style={{cursor:'pointer',marginLeft:'-10px' }}>delete</i>
      </td>
      <td>{a[index] >= 0 ? a[index] : "Expired "+ Math.abs(a[index])+" days ago" }</td>
      </tr>
      ))
    }
  </tbody>
</table>
<br />
<img src={image} alt="red flag" style={{width:'20px',marginRight:'1px'}}/> <span>indicates your todo is expired</span>
    </div>
  )
}

export default Todo